<igx-grid #gridProfileMassUpdatezzz id="gridProfileMassUpdatezzz"  [data]="this.parkerStateService.parkerUpdateList" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
paste-handler  [primaryKey]="'parkerId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
[emptyGridMessage]="'Parker Mass Update List Empty'"  [clipboardOptions]="options">
<igx-column field="status" header="Status" width="100px" required >
     <ng-template igxCell let-value let-cell="cell">
       <div class="cell__inner">
            <ng-container *ngIf="value === false">
                Error
            </ng-container>
            <ng-container  *ngIf="value === true">
                Success
            </ng-container>
        </div>
    </ng-template>
   
</igx-column>
<igx-column field="parkerId" header="Parker Id*" [sortable]="true" width="225px" required ></igx-column>
<igx-column field="lastName" header="Last Name" width="125px" required ></igx-column>
<igx-column field="firstName" header="First Name" width="125px" required ></igx-column>
<igx-column field="companyName" header="Company" width="250px" required ></igx-column>
<igx-column field="rate" header="Rate" width="100px" required >
    <ng-template igxCell let-value let-cell="cell">
    <div class="cell__inner">
        {{ value | currency}}
     </div>
     </ng-template>
</igx-column>
<igx-column field="parkerPayType" header="Payment" width="125px" required ></igx-column>
<igx-column field="invoiceDeliveryMethod" header="Delivery" width="100px" required ></igx-column>
<igx-column field="errorSource" header="Error Source" width="150px" required ></igx-column>
<igx-column field="description" header="Description" width="270px" required ></igx-column>

<igx-grid-toolbar>
    <igx-grid-toolbar-actions>
        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
    </igx-grid-toolbar-actions>
</igx-grid-toolbar>

</igx-grid>


